import {fromNewAdToCardThumbnailContract, fromRentingAdToCardThumbnailContract} from './mappers.js'

export const CONFIG_BY_OFFER_TYPE_NEW = {
  title: 'MODEL_DETAIL.ADS.TITLE_NEW',
  pathPattern: 'ADS_LIST_MAKE_MODEL_NEW_VEHICLE_PATH_PATTERN',
  mapper: fromNewAdToCardThumbnailContract
}

export const CONFIG_BY_OFFER_TYPE_RENTING = {
  title: 'MODEL_DETAIL.ADS.TITLE_RENTING',
  pathPattern: 'ADS_LIST_SUBSCRIPTION_MAKE_MODEL_RENTING_PATH_PATTERN',
  mapper: fromRentingAdToCardThumbnailContract
}
